var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"team-access-controller-main"},[_vm._m(0),_c('div',{staticClass:"team-access-controller-content"},[_c('el-container',{staticClass:"web-resource-container"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"team-access-controller-header"},[_c('div',{staticClass:"header-left"}),_c('div',{staticClass:"header-right"})])
}]

export { render, staticRenderFns }